import User from '../General/User';

export interface PackageMessage {
  id?: number;
  date?: string;
  text: string;
  type_message: MESSAGE_TYPES;
  origin_user_data?: User | number;
  destination_users_data?: number[];
  package: number;
}

export const enum MESSAGE_TYPES {
  INFORMATIVO = 0,
  CHAT = 1,
  PUSH_NOTIFICATION = 2,
}
